export default "__VITE_ASSET__DmJAL0UB__"